import { ModalAction } from '@Actions/index';

const initialState = {
  ModalComponent: null as React.ComponentClass,
  modalProps: {}
};

export const modalReducer = function (state = initialState, action: ModalAction) {
  switch (action.type) {
    case 'SHOW_MODAL':
      return {
        ModalComponent: action.ModalComponent,
        modalProps: action.modalProps
      };
    case 'CLOSE_MODAL':
      return initialState;
    default:
      return state;
  }
};
